import React from 'react';
import { SearchTextInputProps } from './types';
import { ReactComponent as MagnifyingGlass } from '../../../media/MagnifyingGlass.svg';
import cn from 'classnames';
import styles from './BookingSearchTextInput.module.css';
import TextInput from '../TextInput/TextInput';

const BookingSearchTextInput = ({
  validationError,
  defaultValue,
  id,
  imageAltText,
  careType,
  ...props
}: SearchTextInputProps) => {
  return (
    <TextInput
      onClick={props.onClick}
      validationError={validationError}
      defaultValue={defaultValue}
      id={id}
      {...props}
    >
      <div className={styles.searchTextInputWrapper} onClick={props.onClick}>
        <div className={styles.careTypeWrapper}>
          <label className={styles.careTypeWrapperLabel}>{careType}</label>
        </div>
        <div
          className={cn(
            styles.iconInputDivider,
            validationError && styles.invalid
          )}
        ></div>
        {!validationError && <MagnifyingGlass className={styles.searchIcon} />}
      </div>
    </TextInput>
  );
};

export default BookingSearchTextInput;
